import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { DEVELOPER_CONTEXT_REPOSITORY } from '../domain/repositories/developer-context.repository';
import { DeveloperContextRemoteDatasource } from './datasources/remote/developer-context.remote-datasource';
import { DeveloperOrganizationMapper } from './mappers/developer-organization.mapper';
import { DeveloperContextRepositoryImpl } from './repositories/developer-context.repository.impl';

export function provideDeveloperContextData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DeveloperOrganizationMapper,
    DeveloperContextRemoteDatasource,
    { provide: DEVELOPER_CONTEXT_REPOSITORY, useClass: DeveloperContextRepositoryImpl },
  ]);
}
